import { render } from "./IVkCamp.vue?vue&type=template&id=b0f42246"
import script from "./IVkCamp.vue?vue&type=script&lang=js"
export * from "./IVkCamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__